module.exports = __webpack_public_path__ + "static/media/g-1.5ecb2136.svg";